// 📁 lib/ga.ts
import ReactGA from 'react-ga4';

const GA_MEASUREMENT_ID = 'G-0BV90FKZ7S';
const IS_PRODUCTION = import.meta.env.PROD;

export function initGA() {
  if (!IS_PRODUCTION) {
    return;
  }
  
  try {
    ReactGA.initialize(GA_MEASUREMENT_ID);
  } catch (error) {
    // Continue silently
  }
}

export function trackPageView(path: string) {
  if (!IS_PRODUCTION) {
    return;
  }
  
  try {
    // Ensure path is properly formatted and encoded
    const cleanPath = path.startsWith('/') ? path : `/${path}`;
    
    // Use the ReactGA API which handles URL encoding internally
    ReactGA.send({ 
      hitType: 'pageview', 
      page: cleanPath,
      // Add additional parameters to ensure proper URL construction
      location: window.location.origin + cleanPath
    });
  } catch (error) {
    // Continue silently
  }
}

export function trackEvent(event: {
  category: string;
  action: string;
  label?: string;
  value?: number;
}) {
  if (!IS_PRODUCTION) {
    return;
  }
  
  try {
    ReactGA.event(event);
  } catch (error) {
    // Continue silently
  }
}